import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import history from '../../routes/history';
import useOnMount from '../../hooks/useOnMount';
import MainNavigation from '../MainNavigation/MainNavigation';
import Header from '../Header/Header';
import useStyles from './PageLayout.styles';

interface IProps{
  footer?: boolean;
}

const PageLayout: FunctionComponent<IProps> = ({
  children,
  footer,
}) => {
  const classes = useStyles();
  const id = 'page-layout';

  useOnMount(() => {
    const unlisten = history.listen(() => {
      const container = document.getElementById(id);

      if (container) {
        container.scrollTop = 0;
      }
    });
    return () => {
      unlisten();
    };
  });

  return (
    <div className={classes.container}>
      <MainNavigation />
      <div className={classes.content}>
        <Header />
        <div
          id={id}
          className={cx(classes.main, {
            [classes.mainWithFooter]: footer,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
